import { getRequestProps } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { stringifyUrl } from "query-string";
export function SearchRequestFormatter(message) {
    let { baseUrl, endpoint, method, headers, body, params } = getRequestProps(ConnectionNames.search, message);
    headers["Content-Type"] = "application/json; charset=utf-8";
    let queryStringParams = {};
    if (method === "GET") {
        queryStringParams = params;
    }
    else {
        body = JSON.stringify(params);
    }
    const query = stringifyUrl({
        url: `${baseUrl}${endpoint}`,
        query: queryStringParams
    }, {
        skipNull: true,
        sort: false
    });
    return new Request(query, {
        method,
        headers,
        body
    });
}
//# sourceMappingURL=SearchRequestFormatter.js.map